import { Component, Inject, OnInit } from '@angular/core';
import { combineLatest, distinctUntilChanged, map, Subscription } from 'rxjs';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Logger } from 'src/app/@shared';
import { Sort } from '@angular/material/sort';
import { PageEvent } from '@angular/material/paginator';
import { Offer, OfferGroupDomain, OfferPromo, PromoDomain, OfferPromoService } from '../..';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';

const log = new Logger('UploadAssetsOfferGroupsComponent');

@Component({
  selector: 'app-upload-assets-offer-groups',
  templateUrl: './upload-assets-offer-groups.component.html',
  styleUrls: ['./upload-assets-offer-groups.component.scss']
})

export class UploadAssetsOfferGroupsComponent<TOfferPromo extends OfferPromo, TPromoDomain extends PromoDomain<OfferPromo>> implements OnInit {
  selectedOfferGroup: any;
  search = new FormControl<string>('');
  viewModel$ = combineLatest([
    this.offerpromoService.uploadOfferGroups$,
    this.offerpromoService.isLoading$,
    this.offerpromoService.uploadOfferGroupsTotalRecords$,
    this.offerpromoService.uploadOfferGroupsPage$,
  ]).pipe(
    map(([offers, isLoading, totalRecords, page]) => {
      return { offers, isLoading, totalRecords, page }
    }),
  );
  flexMediaWatcher!: Subscription;
  displayedColumns = ['Name', 'Headline', 'BodyCopy', 'Actions'];
  constructor(private offerpromoService: OfferPromoService<TOfferPromo, TPromoDomain>, private mediaObserver: MediaObserver,
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
    public dialogRef: MatDialogRef<UploadAssetsOfferGroupsComponent<TOfferPromo, TPromoDomain>>) { }

  ngOnInit(): void {
    log.debug('init');
    this.offerpromoService.eventId = this.dialogData?.event?.Detail?.Id;
    const getAlias = (MediaChange: MediaChange[]) => {
      return MediaChange[0].mqAlias;
    };

    this.flexMediaWatcher = this.mediaObserver
      .asObservable()
      .pipe(
        distinctUntilChanged(
          (x: MediaChange[], y: MediaChange[]) => getAlias(x) === getAlias(y)
        ))
      .subscribe((change) => {
        if (change.some(x => x.mqAlias === 'xs')) {
          this.displayedColumns = ['Name'];
        }
        else if (change.some(x => x.mqAlias === 'sm')) {
          this.displayedColumns = ['Name', 'Headline'];
        }
        else {
          this.displayedColumns = ['Name', 'Headline', 'BodyCopy', 'Actions'];
        }
      });
  }

  updateSelectedOfferGroup(offerGroup: OfferGroupDomain<Offer>) {
    this.selectedOfferGroup = offerGroup;
  }

  saveData() {
    if (this.selectedOfferGroup) {
      this.dialogRef.close(this.selectedOfferGroup);
      this.offerpromoService.uploadOfferGroupsSearch('');
    }
  }
  onSearch(event: any) {
    this.offerpromoService.uploadOfferGroupsSearch(event.target.value);
  }

  clearSearch() {
    this.search.setValue('');
    this.offerpromoService.uploadOfferGroupsSearch('');
   }


  closeDialog() {
    this.dialogRef.close();
    this.offerpromoService.uploadOfferGroupsSearch('');
  }

  onSort(sortState: Sort): void {
    this.offerpromoService.uploadOfferGroupsSort(sortState);
  }

  onPage(pageEvent: PageEvent): void {
    this.offerpromoService.uploadOfferGroupsPage(pageEvent);
  }

}
